import thousandCommas from 'components/Dashboard/helpers/thousandCommas';
import uppercaseFirstLetter from 'components/Dashboard/utilities/uppercaseFirstLetter';
import { PricingPopUpData } from './PopUpCheckout';

const changeDecimalValues = (value) => {
  return value % 1 === 0 ? value : value.toFixed(2);
};

const DataHubTotalPlanTable = ({ numberOfUsers, period, isPaidFor, userSubscribed }) => {
  const periodCapitalize = uppercaseFirstLetter(period);
  const pricePerUser = PricingPopUpData.DataHub[`price${periodCapitalize}`];
  const finalPrice = numberOfUsers * pricePerUser * (period === 'annually' ? 12 : 1);

  return (
    <table className='table confirmation-pricing-table'>
      <tbody>
        <tr className='items-information'>
          <td>Data Hub</td>
          <td>${thousandCommas(changeDecimalValues(finalPrice))}</td>
        </tr>
        <tr>
          <td>Subtotal</td>
          <td>${thousandCommas(changeDecimalValues(finalPrice))}</td>
        </tr>
        <tr>
          <td>
            <span>Total due {isPaidFor ? 'next invoice' : 'today'}</span>
          </td>
          <td>${thousandCommas(changeDecimalValues(finalPrice))}</td>
        </tr>
        {userSubscribed && (
          <tr>
            <td className='pt-0 pr-4' colSpan={2}>
              <span className='main-light-text d-block font-weight-normal paragraph-p3 bg-light-blue-hovered rounded border py-2 px-3'>
                Upgrades to your current subscription will be charged today on a pro rata basis
              </span>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default DataHubTotalPlanTable;
